var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProject = function SvgProject(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.833 2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-9a1 1 0 0 1-.832-.445L8.298 2zM1.712.879A3 3 0 0 1 3.833 0h5a1 1 0 0 1 .832.445L11.37 3h8.464a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3h-16a3 3 0 0 1-3-3V3a3 3 0 0 1 .88-2.121",
    clipRule: "evenodd"
  })));
};
export default SvgProject;